<template>
  <div id="weeklyReport" element-loading-background="rgba(255, 255, 255, 0.4)">
    <el-form :model="weeklyReportForm" ref="weeklyReportForm" label-width="190px">
      <el-collapse v-model="activeNames">
        <el-collapse-item title="Basic Information of Project " name="1">
          <el-row>
            <el-col :span="0">
              <el-form-item prop="id">
                <el-input  v-model="weeklyReportForm.id" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Project Manager:" prop="projectManager">
                <el-select
                  v-model="weeklyReportForm.projectManager"
                  clearable
                  filterable
                  remote
                  disabled
                  :remote-method="value => searchManager('projectManagerList', value)"
                >
                  <el-option v-for="(item, index) in projectManagerList.slice(0, 10)" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Technical Manager:" prop="developmentLeader">
                <el-select
                  v-model="weeklyReportForm.developmentLeader"
                  clearable
                  filterable
                  remote
                  disabled
                  :remote-method="value => remoteMethod('developmentLeaderList', value)"
                >
                  <el-option v-for="(item, index) in developmentLeaderList.slice(0, 10)" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Major Project Level:" prop="majorProjectLevel">
                <el-select clearable v-model="weeklyReportForm.majorProjectLevel" disabled>
                  <el-option
                    v-for="item in majorProjectLevel"
                    :key="item.labelKey"
                    :label="item.labelValue"
                    :value="item.labelKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Sub Industry:" prop="customerIndustry">
                <el-select clearable v-model="weeklyReportForm.customerIndustry" disabled>
                  <el-option
                    v-for="item in customerIndustry"
                    :key="item.labelKey"
                    :label="item.labelValue"
                    :value="item.labelKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="Project Overview:" prop="projectSurvey" :rules="[{ required: true, message: 'Please input'}]">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" clearable disabled v-model="weeklyReportForm.projectSurvey" maxlength="255" placeholder="Please input" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="Overall Project Progress" name="2">
          <el-row>
            <el-col :span="24">
              <el-form-item label="Overall Project Progress:" prop="overallProgress" :rules="[{ required: true, message: 'Please input'}]">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" clearable disabled v-model="weeklyReportForm.overallProgress" maxlength="255" placeholder="Please input" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="Project Health, Risks & Issues and Reponse Measures" name="3">
          <el-row>
            <el-col :span="12">
              <el-form-item label="Project Overall Health:" prop="riskLevel">
                <el-select clearable v-model="weeklyReportForm.riskLevel" placeholder="Please select" disabled>
                  <el-option
                    v-for="item in riskLevel"
                    :key="item.labelKey"
                    :label="item.labelValue"
                    :value="item.labelKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-table :data="weeklyReportForm.riskList" border size="small" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column prop="riskTypeDesc" label="Risk Type"></el-table-column>
            <el-table-column prop="riskLevelDesc" label="Risk Level" align="center"></el-table-column>
            <el-table-column prop="riskDesc" label="Risk Description"></el-table-column>
            <el-table-column prop="responseMeasures" label="Response Measures"></el-table-column>
            <el-table-column prop="personResponsible" label="Owner"></el-table-column>
            <el-table-column prop="plannedClosingTime" label="Planned Closing Date">
              <template v-slot="scope">
                {{ scope.row.plannedClosingTime ? moment(scope.row.plannedClosingTime).format('YYYY-MM-DD') : ''}}
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="Weekly Progress" name="4">
          <el-row>
            <el-col :span="12">
              <el-form-item label="Weekly Report Period:" prop="weeklyStartEndDate" :rules="[{ required: true, message: 'Please input' }]">
                <el-date-picker
                  v-model="weeklyReportForm.weeklyStartEndDate"
                  type="daterange"
                  disabled
                  range-separator="-"
                  start-placeholder=""
                  end-placeholder=""
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Project Duration:" prop="projectStartEndDate">
                <el-date-picker
                  v-model="weeklyReportForm.projectStartEndDate"
                  type="daterange"
                  range-separator="-"
                  start-placeholder=""
                  end-placeholder=""
                  disabled
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-table :data="weeklyReportForm.thisWeekWorkProgressList" border class="week-table" size="small" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column label="No." type="index" sortable width="85" align="center"></el-table-column>
            <el-table-column prop="jobContent" label="Work Completed" align="center"></el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="Next Week Plan" name="5">
          <el-table :data="weeklyReportForm.nextWeekWorkProgressList" border class="week-table" size="small" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column label="No." type="index" sortable width="85" align="center"></el-table-column>
            <el-table-column prop="jobContent" label="Work Contents" align="center"></el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="Project Milestone" name="6">
          <el-table :data="weeklyReportForm.milestoneList" border size="small" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
            <el-table-column label="Key Milestone" prop="criticalMilestone" min-width="45">
              <template v-slot="scope">
                {{ scope.row.criticalMilestone === 1 ? 'Yes' : scope.row.criticalMilestone === 0 ? 'No' : '' }}
              </template>
            </el-table-column>
            <el-table-column label="Key Task" prop="missionCritical" min-width="45"></el-table-column>
            <el-table-column label="Key Task Description" prop="missionCriticalDesc" min-width="45"></el-table-column>
            <el-table-column label="Progress Percentage (%)" prop="progressRatio" min-width="45"></el-table-column>
            <el-table-column label="Risk Level" prop="riskLevelDesc" min-width="45"></el-table-column>
            <el-table-column label="Current Status" prop="statusDesc" min-width="45"></el-table-column>
            <el-table-column label="Start Date" prop="startTime" min-width="45">
              <template v-slot="scope">
                {{ scope.row.startTime ? moment(scope.row.startTime).format('YYYY-MM-DD') : ''}}
              </template>
            </el-table-column>
            <el-table-column label="End Date" prop="endTime" min-width="45">
              <template v-slot="scope">
                {{ scope.row.endTime ? moment(scope.row.endTime).format('YYYY-MM-DD') : ''}}
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </el-form>
  </div>
</template>
<script>
import moment from 'moment';
  export default {
    name: 'weeklyReportHis',
		props: {
			id: {
        type: Number,
        default: null,
      },
      historyWeeklyData: {
				type: Object,
        default: {}
      }
		},
		watch: {
      // historyWeeklyData(newValue, oldValue) {
      //   console.log('newValue', newValue)
			// 	this.getSelectInfo();
			// }
		},
    created () {
      this.getSelectInfo();
      this.getWeeklyInfo();
    },
    data () {
      return {
        moment,
        activeNames: ['1', '2', '3', '4', '5', '6'],
        weeklyReportForm: {},
        projectManagerList: [],
        majorProjectLevel: [],
        customerIndustry: [],
        developmentLeaderList: [],
        riskLevel: [],
        riskData: [],
        ganttDta: [],
        allData: {},
      }
    },
    methods: {
			getWeeklyInfo() {
        const data = this.historyWeeklyData;
        let nextWeekWorkProgressListNew = [];
        let thisWeekWorkProgressListNew = [];
        data.nextWeekWorkProgressList && data.nextWeekWorkProgressList.forEach(item => {
          nextWeekWorkProgressListNew.push({
            jobContent: item,
          })
        })
        data.thisWeekWorkProgressList && data.thisWeekWorkProgressList.forEach(item => {
          thisWeekWorkProgressListNew.push({
            jobContent: item,
          })
        })
        this.weeklyReportForm = {
          ...data,
          nextWeekWorkProgressList: nextWeekWorkProgressListNew.length === 0 ? [{}] : nextWeekWorkProgressListNew,
          thisWeekWorkProgressList: thisWeekWorkProgressListNew.length === 0 ? [{}] : thisWeekWorkProgressListNew,
          projectStartEndDate: [data.projectPlanStartDate, data.projectPlanEndDate],
          weeklyStartEndDate: data.reportStartDate ? [data.reportStartDate, data.reportEndDate] : [],
        }
			},
			getSelectInfo() {
				let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
				let configKeyList = [
					'majorProjectLevel',
					'customerIndustry',
          'riskLevel',
				]
				let str = '';
				configKeyList.forEach(item => {
					str += `&configKeyList=${item}`;
				})
				url = url + str.substring(1)
				const _this = this
				this._post(url).then(
					res => {
						if (res.data && res.code === 200) {
							Object.keys(res.data).forEach(function(key) {
								_this[key] = res.data[key];
							});
						}
					}
				)
			},
    },
  }
</script>
<style lang="less" scoped>
#weeklyReport {
	.el-form {
		padding: 20px 0;
		/deep/.el-input {
			max-width: 350px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 12px;
		}
		/deep/.el-input-number {
			width: 100%;
			.el-input__inner {
				text-align: left;
			}
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
			max-width: 350px;
		}
    /deep/.el-date-editor .el-range__icon {
      line-height: 26px;
    }
    /deep/.el-textarea.is-disabled .el-textarea__inner,
    /deep/.el-range-editor.is-disabled input {
      color: #606266;
    }
    .hasStar span {
      color: #F56C6C;
      padding-left: 1px;
    }
    .week-table {
      /deep/td.el-table__cell {
        // padding: 20px 0 0 0;
      }
      /deep/.el-form-item {
        margin-bottom: 20px;
      }
    }
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/weeklyReport/historyDetail.vue